import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Operation } from "../../entity/Operation";

interface OperationState {
    operations: Operation[];
}

const initialState: OperationState = {
    operations: [],
};  

const operationSlice = createSlice({
    name: "operation",
    initialState,
    reducers: {
        setOperations: (state, action: PayloadAction<Operation[]>) => {
            state.operations = action.payload;
        },
    },
});

export const { setOperations } = operationSlice.actions;
export default operationSlice.reducer;
